import { i18n } from '@lt/localization';

export const TEXT = {
  hotel: {
    tourType: 'Отели',
    toursType: i18n.t('tourType.onlyHotel.plural'),
  },
  package: {
    tourType: 'Выберите тур',
    toursType: i18n.t('tourType.withFlights.plural'),
  },
};
